"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray2(o, minLen); }
function _arrayLikeToArray2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey2(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
/*!
 * Interview Questions - Version: 2.16.4
 * Indeed - Copyright (c) 2026
 * This file is generated automatically. Do not edit.
 *
 * Contains sources adapted from Twitter Bootstrap v4.0.0-alpha.3, which are
 * licensed under MIT (https:
 */

(function ($) {
  $(document).ready(function () {
    var toggleSwitch = false;
    var toogleDelay = 0;
    $(".has-dropdown > a").click(function (event) {});
    $(".has-dropdown").hover(function () {
      var that = this;
      toggleSwitch = !toggleSwitch;
      if (toggleSwitch) {
        $(that).find('> .menu-dropdown').fadeIn();
        $(that).addClass('dropdown-active');
      } else {
        $(that).find('> .menu-dropdown').fadeOut();
        $(that).removeClass('dropdown-active');
      }
    });
    $(".show-more-questions-text").on('click', function (event) {
      event.preventDefault();
      $(".extra-question, .show-more-questions-text").toggleClass('text-hidden');
      if ($(this).hasClass('show-more-text')) {
        $(".extra-question").first().find('a').focus();
      } else if ($(this).hasClass('show-fewer-text')) {
        $(".show-more-text").focus();
      }
    });
    if (!$('.opt-floating-steps').length) {
      return;
    }
    $('.opt-floating-steps').slick({
      accessibility: false,
      slidesToShow: 3,
      infinite: false,
      dots: false,
      arrows: false,
      centerPadding: '10px',
      responsive: [{
        breakpoint: 768,
        settings: {
          accessibility: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          arrows: true,
          prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" aria-disabled="false"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">' + '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M14.112 18.002c.2.2.52.204.716.008l.707-.707a.507.507 0 00-.009-.716L10.94 12l4.587-4.587c.2-.2.205-.521.01-.716l-.708-.708a.507.507 0 00-.716.01l-5.648 5.647c-.1.1-.148.234-.143.367.002.124.05.247.143.34l.001.001a.758.758 0 00.008.008l5.64 5.64z"/></svg>' + '</button>',
          nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" aria-disabled="false">' + '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M9.888 5.998a.506.506 0 00-.716-.008l-.707.707a.506.506 0 00.01.716L13.06 12l-4.587 4.587c-.2.2-.204.521-.009.716l.707.707a.507.507 0 00.717-.009l5.647-5.648c.1-.1.148-.233.144-.366a.492.492 0 00-.144-.34v-.001a.611.611 0 00-.009-.009L9.888 5.998z"/></svg>' + '</button>'
        }
      }]
    });
    $('.opt-handle, .opt-floating-head').on('click', function (event) {
      $('.opt-floating-cta').toggleClass('opt-slide-left');
      $('.opt-floating-head').focus();
    });
  });
})(jQuery);
var METRIC_EMIT_DELAY_IN_MS = 2000;
var MAX_RETRY_ATTEMPTS = 5;
var _retry = function _retry(fn) {
  var retryAttempts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MAX_RETRY_ATTEMPTS;
  var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : METRIC_EMIT_DELAY_IN_MS;
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _this = this;
    var _len2,
      args,
      _key2,
      _loop,
      _ret,
      i,
      _args2 = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          for (_len2 = _args2.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = _args2[_key2];
          }
          _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
            var exponentialDelay, result;
            return _regeneratorRuntime().wrap(function _loop$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  exponentialDelay = delay * Math.pow(2, i);
                  _context.prev = 1;
                  result = fn.call.apply(fn, [_this].concat(args));
                  if (!result) {
                    _context.next = 5;
                    break;
                  }
                  return _context.abrupt("return", {
                    v: result
                  });
                case 5:
                  _context.next = 7;
                  return new Promise(function (r) {
                    return setTimeout(r, exponentialDelay);
                  });
                case 7:
                  _context.next = 13;
                  break;
                case 9:
                  _context.prev = 9;
                  _context.t0 = _context["catch"](1);
                  _context.next = 13;
                  return new Promise(function (r) {
                    return setTimeout(r, exponentialDelay);
                  });
                case 13:
                case "end":
                  return _context.stop();
              }
            }, _loop, null, [[1, 9]]);
          });
          i = 0;
        case 3:
          if (!(i <= retryAttempts)) {
            _context2.next = 11;
            break;
          }
          return _context2.delegateYield(_loop(), "t0", 5);
        case 5:
          _ret = _context2.t0;
          if (!_ret) {
            _context2.next = 8;
            break;
          }
          return _context2.abrupt("return", _ret.v);
        case 8:
          i++;
          _context2.next = 3;
          break;
        case 11:
        case "end":
          return _context2.stop();
      }
    }, _callee);
  }));
};
var LinkingWidgetConstants = {
  TSV_DATA_SCHEMA_VERSION: 1,
  TSV_DATA_BASE_URL_DEV: "https://d3idcws7fdm94h.cloudfront.net/content-transfer/linking-widget",
  TSV_DATA_BASE_URL_QA: "https://d3v75sr4bu5gc4.cloudfront.net/content-transfer/linking-widget",
  TSV_DATA_BASE_URL_PROD: "https://d341ezm4iqaae0.cloudfront.net/content-transfer/linking-widget",
  TEMPLATE_TO_DISPLAYED_TEXT_MAPPING: {},
  RELATED_CONTENT_SLUG_TRANSLATION: {
    "de": {
      "interviewfragen": "interview-questions",
      "stellenbeschreibung": "job-description",
      "recruitingtipps": "how-to-hire"
    },
    "es": {
      "descripción-del-empleo": "job-description",
      "preguntas-entrevista": "interview-questions",
      "como-contratar": "how-to-hire"
    },
    "fr": {
      "questions-entretien-dembauche": "interview-questions",
      "description-du-poste": "job-description",
      "comment-recruter": "how-to-hire"
    },
    "fr_CA": {
      "questions-entrevue": "interview-questions",
      "comment-embaucher": "how-to-hire"
    },
    "it": {
      "descrizione-dell'-offerta": "job-description",
      "colloquio-domande": "interview-questions",
      "come-assumere": "how-to-hire"
    },
    "ja": {
      "求人票の書き方": "job-description"
    },
    "nl": {
      "sollicitatievragen": "interview-questions",
      "functiebeschrijving": "job-description",
      "recruitment-tips": "how-to-hire"
    },
    "pt": {
      "descrição-da-vaga": "job-description"
    },
    "sv": {
      "jobbeskrivning": "job-description"
    }
  },
  RELATED_CONTENT_DISPLAY_THRESHOLD_MIN: 2,
  RELATED_TITLES_DISPLAY_THRESHOLD_MIN: 2,
  RELATED_TITLES_DISPLAY_THRESHOLD_MAX: 5,
  RELATED_CONTENT: "related_content",
  RELATED_SLUGS: "related_slugs",
  RELATED_CONTENT_ISID: "related_scaled",
  RELATED_SLUGS_ISID: "related_titles",
  LINKING_WIDGET_STATE_UNINITIALIZED: "linking-widget-uninitialized",
  LINKING_WIDGET_STATE_ERROR: "linking-widget-error",
  LINKING_WIDGET_STATE_EMPTY: "linking-widget-empty",
  LINKING_WIDGET_STATE_CONTENT_COLUMN_ONLY: "linking-widget-content-column-only",
  LINKING_WIDGET_STATE_TITLE_COLUMN_ONLY: "linking-widget-title-column-only",
  LINKING_WIDGET_STATE_TITLE_TWO_COLUMNS: "linking-widget-two-columns"
};
var LinkingWidget = /*#__PURE__*/function () {
  function LinkingWidget() {
    var _this2 = this;
    _classCallCheck(this, LinkingWidget);
    if (!document.querySelector("#linking-widget")) {
      console.error("Linking widget element does not exist");
      _retry(function () {
        if (!window.commonMetricsLibrary || !window.signals_transport) {
          return false;
        }
        window.commonMetricsLibrary.report({
          "data-tn-element": LinkingWidgetConstants.LINKING_WIDGET_STATE_UNINITIALIZED,
          "data-tn-action": "impression"
        });
        return true;
      })();
      LinkingWidget.hideExpandedWrapperIfEmpty();
      return;
    }
    try {
      var hasError = false;
      this.setLinkingWidgetTurnstileState(LinkingWidgetConstants.LINKING_WIDGET_STATE_UNINITIALIZED);
      if (!this.shouldInitializeLinkingWidget()) {
        this.reportLinkingWidgetTurnstileState();
        LinkingWidget.hideExpandedWrapperIfEmpty();
        return;
      }
      this.fetchFile("".concat(this.getCDNBaseUrl(), "/").concat(LinkingWidgetConstants.TSV_DATA_SCHEMA_VERSION, "/").concat(this.getLocale(), ".tsv")).then(function (tsvString) {
        if (_this2.isSet(tsvString)) {
          _this2.linkingWidgetData = _this2.parseTSVToObject(tsvString);
          _this2.initializeLinkingWidget(_this2.linkingWidgetData);
        }
      })["catch"](function (error) {
        _this2.setLinkingWidgetTurnstileState(LinkingWidgetConstants.LINKING_WIDGET_STATE_ERROR);
        hasError = true;
        console.error("Unable to initialize linking widget.", error);
      })["finally"](function () {
        if (hasError) {
          _this2.reportLinkingWidgetTurnstileState();
          LinkingWidget.hideExpandedWrapperIfEmpty();
          return;
        }
        var contentColumnCount = document.querySelectorAll("#linking-widget-related-content h3").length;
        var titleColumnCount = document.querySelectorAll("#linking-widget-related-titles h3").length;
        if (contentColumnCount == 0 && titleColumnCount == 0) {
          _this2.setLinkingWidgetTurnstileState(LinkingWidgetConstants.LINKING_WIDGET_STATE_EMPTY);
          LinkingWidget.hideExpandedWrapperIfEmpty();
        } else {
          if (contentColumnCount == 1 && titleColumnCount == 1) {
            _this2.setLinkingWidgetTurnstileState(LinkingWidgetConstants.LINKING_WIDGET_STATE_TITLE_TWO_COLUMNS);
          } else if (contentColumnCount == 1) {
            _this2.setLinkingWidgetTurnstileState(LinkingWidgetConstants.LINKING_WIDGET_STATE_CONTENT_COLUMN_ONLY);
          } else if (titleColumnCount == 1) {
            _this2.setLinkingWidgetTurnstileState(LinkingWidgetConstants.LINKING_WIDGET_STATE_TITLE_COLUMN_ONLY);
          }
        }
        _this2.reportLinkingWidgetTurnstileState();
      });
    } catch (error) {
      console.error("Unable to initialize linking widget.", error);
      this.setLinkingWidgetTurnstileState(LinkingWidgetConstants.LINKING_WIDGET_STATE_ERROR);
      this.reportLinkingWidgetTurnstileState();
    }
  }
  return _createClass(LinkingWidget, [{
    key: "escapeHtml",
    value: function escapeHtml(str) {
      if (str == null) return '';
      var div = document.createElement("div");
      div.appendChild(document.createTextNode(String(str)));
      return div.innerHTML;
    }
  }, {
    key: "isSet",
    value: function isSet(variable) {
      return !(typeof variable === 'undefined' || variable === null);
    }
  }, {
    key: "getGnavConfig",
    value: function getGnavConfig() {
      var gnavConfigElement = document.getElementById("_indeed_gnav_config");
      if (gnavConfigElement !== null) {
        var gnavConfig = JSON.parse(gnavConfigElement.textContent);
        return gnavConfig;
      }
      return null;
    }
  }, {
    key: "getLocale",
    value: function getLocale() {
      var gnavConfig = this.getGnavConfig();
      if (gnavConfig !== null && gnavConfig.hasOwnProperty("language")) {
        var hl = gnavConfig.language;
        var co = gnavConfig.country || "US";
        return "".concat(hl, "_").concat(co);
      }
      var pageWrapElement = document.getElementById("pageWrap");
      if (pageWrapElement && pageWrapElement.className.trim() !== "") {
        var locale = pageWrapElement.className.split(" ")[0];
        var twoOrFourLetterLocaleRegex = /^(([a-zA-Z]{2}_[a-zA-Z]{2})|[a-zA-Z]{2})$/;
        if (twoOrFourLetterLocaleRegex.test(locale)) {
          var _hl = locale.split("_")[0];
          var _co = locale.split("_")[1] || "US";
          return "".concat(_hl, "_").concat(_co);
        }
      }
      return "en_US";
    }
  }, {
    key: "getTranslatedContentTypes",
    value: function getTranslatedContentTypes(contentType) {
      var locale = this.getLocale();
      var language = locale.split("_")[0];
      if (locale in LinkingWidgetConstants.RELATED_CONTENT_SLUG_TRANSLATION && contentType in LinkingWidgetConstants.RELATED_CONTENT_SLUG_TRANSLATION[locale]) {
        return LinkingWidgetConstants.RELATED_CONTENT_SLUG_TRANSLATION[locale][contentType];
      } else if (language in LinkingWidgetConstants.RELATED_CONTENT_SLUG_TRANSLATION && contentType in LinkingWidgetConstants.RELATED_CONTENT_SLUG_TRANSLATION[language]) {
        return LinkingWidgetConstants.RELATED_CONTENT_SLUG_TRANSLATION[language][contentType];
      } else {
        return contentType;
      }
    }
  }, {
    key: "getDisplayedTextForSlug",
    value: function getDisplayedTextForSlug(slug) {
      var _iterator = _createForOfIteratorHelper(this.linkingWidgetData),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var data = _step.value;
          if (data["slug"] === slug) {
            return data["title"];
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      throw new Error("Unable to find displayed text for slug.");
    }
  }, {
    key: "getTitleForRelatedContentColumn",
    value: function getTitleForRelatedContentColumn(displayedTitle) {
      return displayedTitle;
    }
  }, {
    key: "getTitleForRelatedTitlesColumn",
    value: function getTitleForRelatedTitlesColumn() {
      if (LinkingWidgetConstants.TEMPLATE_TO_DISPLAYED_TEXT_MAPPING["RelatedJobTitles"]) {
        return LinkingWidgetConstants.TEMPLATE_TO_DISPLAYED_TEXT_MAPPING["RelatedJobTitles"];
      } else {
        throw new Error("Unable to find displayed text for related titles.");
      }
    }
  }, {
    key: "getCDNBaseUrl",
    value: function getCDNBaseUrl() {
      var hostname = window.location.hostname;
      if (hostname.includes(".wpengine.test")) {
        return LinkingWidgetConstants.TSV_DATA_BASE_URL_DEV;
      } else if (hostname.includes(".wpengine.com")) {
        return LinkingWidgetConstants.TSV_DATA_BASE_URL_QA;
      } else if (hostname.includes(".qa.indeed.net")) {
        return LinkingWidgetConstants.TSV_DATA_BASE_URL_QA;
      } else {
        return LinkingWidgetConstants.TSV_DATA_BASE_URL_PROD;
      }
    }
  }, {
    key: "getIkw",
    value: function getIkw() {
      if (this.isSet(subnavSearchSourceId)) {
        return subnavSearchSourceId.replace("subnav_search_", "");
      }
    }
  }, {
    key: "shouldInitializeLinkingWidget",
    value: function shouldInitializeLinkingWidget() {
      if (typeof TEMPLATE_TO_DISPLAYED_TEXT_MAPPING === 'undefined') {
        return false;
      }
      LinkingWidgetConstants.TEMPLATE_TO_DISPLAYED_TEXT_MAPPING = TEMPLATE_TO_DISPLAYED_TEXT_MAPPING;
      return true;
    }
  }, {
    key: "constructUrl",
    value: function constructUrl(template, slug, isid, ikw) {
      var hire = window.location.pathname.split("/")[1];
      var query = new URLSearchParams();
      var cookieCO = window.IndeedStorageConsent.getCookie("CO");
      if (this.isSet(cookieCO)) {
        query.append("co", cookieCO);
      }
      if (this.isSet(isid)) {
        query.append("isid", isid);
      }
      if (this.isSet(ikw)) {
        query.append("ikw", ikw);
      }
      if (this.isSet(query.toString())) {
        return "/".concat(hire, "/").concat(template, "/").concat(slug, "?").concat(query.toString());
      } else {
        return "/".concat(hire, "/").concat(template, "/").concat(slug);
      }
    }
  }, {
    key: "fetchFile",
    value: function fetchFile(url) {
      return fetch(url).then(function (response) {
        if (response.status === 200) {
          var data = response.text();
          return data;
        } else {
          console.error("Unable to fetch linking widget data");
        }
      })["catch"](function (error) {
        return error;
      });
    }
  }, {
    key: "initializeLinkingWidget",
    value: function initializeLinkingWidget(linkingWidgetData) {
      if (!this.isSet(linkingWidgetData)) {
        console.error("linkingWidgetData is not found");
        return;
      }
      var urlSegments = window.location.pathname.split("/").filter(function (element) {
        return element;
      });
      var slug = urlSegments[urlSegments.length - 1];
      var currentContentType = urlSegments[urlSegments.length - 2];
      var shouldDisplayWidget = false;
      var relatedContent = [];
      var relatedTitles = [];
      var currentLinkingData;
      var _iterator2 = _createForOfIteratorHelper(linkingWidgetData),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var data = _step2.value;
          if (data["slug"] === slug) {
            currentLinkingData = data;
            relatedContent = data[LinkingWidgetConstants.RELATED_CONTENT];
            relatedTitles = this.filterValidRelatedSlugsForCurrentContentType(data[LinkingWidgetConstants.RELATED_SLUGS], currentContentType);
            break;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      if (relatedContent.length >= LinkingWidgetConstants.RELATED_CONTENT_DISPLAY_THRESHOLD_MIN) {
        this.insertTitleForRelatedContentColumn(currentLinkingData);
        this.insertRelatedContent(currentLinkingData);
        var node = document.querySelector("#linking-widget-related-content");
        node.style.display = "flex";
        shouldDisplayWidget = true;
      }
      if (relatedTitles.length >= LinkingWidgetConstants.RELATED_TITLES_DISPLAY_THRESHOLD_MIN) {
        this.insertTitleForRelatedTitlesColumn(currentLinkingData);
        this.insertRelatedTitles(relatedTitles);
        var _node = document.querySelector("#linking-widget-related-titles");
        _node.style.display = "flex";
        shouldDisplayWidget = true;
      }
      if (shouldDisplayWidget) {
        var linkingWidgetNode = document.querySelector("#linking-widget");
        linkingWidgetNode.style.display = "flex";
      }
    }
  }, {
    key: "insertTitleForRelatedContentColumn",
    value: function insertTitleForRelatedContentColumn(slugData) {
      var node = document.querySelector("#linking-widget-related-content .linking-widget-title");
      node.insertAdjacentHTML("afterbegin", "<h3> ".concat(this.getTitleForRelatedContentColumn(slugData["title"]), "</h3>"));
    }
  }, {
    key: "insertTitleForRelatedTitlesColumn",
    value: function insertTitleForRelatedTitlesColumn() {
      var node = document.querySelector("#linking-widget-related-titles .linking-widget-title");
      node.insertAdjacentHTML("afterbegin", "<h3> ".concat(this.getTitleForRelatedTitlesColumn(), "</h3>"));
    }
  }, {
    key: "insertRelatedContent",
    value: function insertRelatedContent(slugData) {
      var urlSegments = window.location.pathname.split("/").filter(function (element) {
        return element;
      });
      var currentContentType = urlSegments[urlSegments.length - 2];
      var _iterator3 = _createForOfIteratorHelper(slugData[LinkingWidgetConstants.RELATED_CONTENT]),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var contentType = _step3.value;
          var node = document.querySelector("#linking-widget-related-content .linking-widget-links");
          var normalizedType = this.getTranslatedContentTypes(contentType);
          var displayedText = LinkingWidgetConstants.TEMPLATE_TO_DISPLAYED_TEXT_MAPPING[normalizedType];
          if (!displayedText) {
            continue;
          }
          var safeType = this.escapeHtml(normalizedType);
          var safeText = this.escapeHtml(displayedText);
          if (currentContentType === contentType) {
            node.insertAdjacentHTML("beforeend", "<li><span class=\"linking-widget-current-page\" data-linking-widget-type=\"".concat(safeType, "\">").concat(safeText, "</span></li>"));
          } else {
            var hrefUrl = this.constructUrl(contentType, slugData["slug"], LinkingWidgetConstants.RELATED_CONTENT_ISID, this.getIkw());
            var safeHref = this.escapeHtml(hrefUrl);
            node.insertAdjacentHTML("beforeend", "<li><a href=\"".concat(safeHref, "\" data-tn-component=\"").concat(LinkingWidgetConstants.RELATED_CONTENT_ISID, "\" data-tn-link=\"").concat(this.getIkw(), "\" data-tn-element=\"linking-widget-link\" data-linking-widget-type=\"").concat(safeType, "\">").concat(safeText, "</a></li>"));
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "insertRelatedTitles",
    value: function insertRelatedTitles(relatedTitles) {
      var urlSegments = window.location.pathname.split("/").filter(function (element) {
        return element;
      });
      var currentContentType = urlSegments[urlSegments.length - 2];
      var _iterator4 = _createForOfIteratorHelper(relatedTitles),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var relatedTitle = _step4.value;
          var node = document.querySelector("#linking-widget-related-titles .linking-widget-links");
          var hrefUrl = this.constructUrl(currentContentType, relatedTitle, LinkingWidgetConstants.RELATED_SLUGS_ISID, this.getIkw());
          var displayedText = this.getDisplayedTextForSlug(relatedTitle);
          node.insertAdjacentHTML("beforeend", "<li><a href=\"".concat(hrefUrl, "\" data-tn-component=\"").concat(LinkingWidgetConstants.RELATED_SLUGS_ISID, "\" data-tn-link=\"").concat(this.getIkw(), "\" data-tn-element=\"linking-widget-link\">").concat(displayedText, "</a></li>"));
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "filterValidRelatedSlugsForCurrentContentType",
    value: function filterValidRelatedSlugsForCurrentContentType(relatedSlugs, currentContentType) {
      var allSlugsForCurrentContentType = [];
      var _iterator5 = _createForOfIteratorHelper(this.linkingWidgetData),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var linkingWidgetObject = _step5.value;
          var slug = linkingWidgetObject["slug"];
          var contentTypeArray = linkingWidgetObject[LinkingWidgetConstants.RELATED_CONTENT];
          if (contentTypeArray.includes(currentContentType)) {
            allSlugsForCurrentContentType.push(slug);
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      var filteredRelatedSlugs = [];
      var _iterator6 = _createForOfIteratorHelper(relatedSlugs),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var relateSlug = _step6.value;
          if (allSlugsForCurrentContentType.includes(relateSlug)) {
            filteredRelatedSlugs.push(relateSlug);
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      return filteredRelatedSlugs.sort().slice(0, LinkingWidgetConstants.RELATED_TITLES_DISPLAY_THRESHOLD_MAX);
    }
  }, {
    key: "parseTSVToObject",
    value: function parseTSVToObject(tsvString) {
      var lines = tsvString.split(/\r\n|\r|\n/).filter(function (element) {
        return element;
      });
      var result = [];
      var headers = lines.shift().split("\t");
      var _iterator7 = _createForOfIteratorHelper(lines),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var line = _step7.value;
          var obj = {};
          var columns = line.split("\t");
          var validLine = true;
          for (var i = 0; i < headers.length; i++) {
            var header = headers[i];
            if (header === "slug" || header === "title") {
              if (columns[i] === "") {
                validLine = false;
                continue;
              }
            }
            if (header === "related_content" || header === "related_slugs") {
              obj[header] = columns[i].replace(/\s/g, "").split(",").filter(function (element) {
                return element;
              });
            } else {
              obj[header] = columns[i];
            }
          }
          if (validLine) {
            result.push(obj);
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      return result;
    }
  }, {
    key: "setLinkingWidgetTurnstileState",
    value: function setLinkingWidgetTurnstileState(state) {
      var e = document.querySelector("#linking-widget");
      e.setAttribute("data-tn-element", state);
    }
  }, {
    key: "reportLinkingWidgetTurnstileState",
    value: function reportLinkingWidgetTurnstileState() {
      _retry(function () {
        var _document$querySelect;
        if (!window.commonMetricsLibrary || !window.signals_transport) {
          return false;
        }
        var e = (_document$querySelect = document.querySelector("#linking-widget")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getAttribute("data-tn-element");
        window.commonMetricsLibrary.report({
          "data-tn-element": e,
          "data-tn-action": "impression"
        });
        return true;
      })();
    }
  }], [{
    key: "hideExpandedWrapperIfEmpty",
    value: function hideExpandedWrapperIfEmpty() {
      var expandedWrapper = document.querySelector(".linking-widget-expanded");
      if (!expandedWrapper) return;
      var hiMount = expandedWrapper.querySelector(".linking-widget-hiring-insights");
      var displayParams = ["total_clicks", "total_resumes", "average_salary"];
      var hiHasData = hiMount && displayParams.some(function (param) {
        var _tag$textContent;
        var tag = document.querySelector("[data-param=\"".concat(param, "\"][data-modal-id=\"").concat(hiMount.id, "\"]"));
        return !!(tag !== null && tag !== void 0 && (_tag$textContent = tag.textContent) !== null && _tag$textContent !== void 0 && _tag$textContent.trim());
      });
      if (!hiHasData) {
        expandedWrapper.style.display = "none";
      }
    }
  }]);
}();
var linkingWidget;
window.addEventListener('DOMContentLoaded', function () {
  return linkingWidget = new LinkingWidget();
}, {
  once: true
});
var EXIT_MODAL_DO_NOT_SHOW_SESSION_STORAGE_KEY = 'exit-modal-do-not-show';
var EXIT_MODAL_SHOW_ONCE_COOKIE_KEY = 'EXIT_MODAL_ALREADY_SHOWN';
var EXIT_MODAL_SHOW_ONCE_COOKIE_TTL = 300000;
var MOBILE_INACTIVITY_POLLING_MS = 1000;
var DESKTOP_DELAY_MS = 1000;
function setExitModalShownCookie() {
  var now = new Date();
  var currentTime = now.getTime();
  now.setTime(currentTime + EXIT_MODAL_SHOW_ONCE_COOKIE_TTL);
  try {
    window.IndeedStorageConsent.setCookie("".concat(EXIT_MODAL_SHOW_ONCE_COOKIE_KEY, "=true;expires=").concat(now.toUTCString(), ";path=/"), window.IndeedStorageConsent.ConsentGroup.Functional);
  } catch (e) {
    console.error(e);
  }
}
function deleteExitModalShownCookie() {
  try {
    window.IndeedStorageConsent.removeCookie(EXIT_MODAL_SHOW_ONCE_COOKIE_KEY, {
      path: '/'
    });
  } catch (e) {
    console.error(e);
  }
}
function checkIfExitModalShownCookieExists() {
  try {
    return window.IndeedStorageConsent.getCookie(EXIT_MODAL_SHOW_ONCE_COOKIE_KEY);
  } catch (e) {
    console.error(e);
    return null;
  }
}
function calculateExitModalStatusForContentTemplates() {
  if (typeof exitModalQueryParameters !== 'undefined') {
    var urlSearchParams = new URLSearchParams(window.location.search);
    var params = Object.keys(Object.fromEntries(urlSearchParams.entries()));
    var hasMatchingQueryParam = params.some(function (param) {
      return exitModalQueryParameters.has(param.toLowerCase());
    });
    if (hasMatchingQueryParam) {
      return true;
    }
  }
  return false;
}
function setupExitModal() {
  var exitModalWrapper = document.querySelector('.exit-modal-wrapper');
  document.body.insertBefore(exitModalWrapper, document.body.firstChild);
  setupExitModalFocusTrap();
  document.querySelector('.exit-modal-close').addEventListener('click', function () {
    var _sessionStorage;
    deleteExitModalShownCookie();
    (_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 || _sessionStorage.setItem(EXIT_MODAL_DO_NOT_SHOW_SESSION_STORAGE_KEY, 'true');
    document.querySelector('.exit-modal-wrapper').classList.add('hide-me');
  });
}
function displayExitModal() {
  setExitModalShownCookie();
  var exitModalWrapper = document.querySelector('.exit-modal-wrapper');
  exitModalWrapper.classList.remove('hide-me');
  exitModalWrapper.focus();
  try {
    if (window.commonMetricsLibrary) {
      window.commonMetricsLibrary.report({
        'data-tn-element': 'smb-exit-modal',
        'data-tn-action': 'impression'
      });
    }
  } catch (error) {
    console.error('Failed to fire event for exit modal view: ', error);
  }
}
function setupExitModalFocusTrap() {
  var exitModalWrapper = document.querySelector('.exit-modal-wrapper');
  var focusableElements = exitModalWrapper.querySelectorAll("a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type='text']:not([disabled]), input[type='radio']:not([disabled]), input[type='checkbox']:not([disabled]), select:not([disabled])");
  var firstFocusableElement = focusableElements[0];
  var lastFocusableElement = focusableElements[focusableElements.length - 1];
  exitModalWrapper.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') {
      if (e.shiftKey) {
        if (document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === lastFocusableElement) {
          firstFocusableElement.focus();
          e.preventDefault();
        }
      }
    }
  });
}
window.addEventListener('DOMContentLoaded', function () {
  var _matchMedia, _matchMedia2;
  var exitModalWrapper = document.querySelector('.exit-modal-wrapper');
  if (!exitModalWrapper) {
    return;
  }
  if (isContentTemplate) {
    var shouldEnableExitModalForContentTemplates = calculateExitModalStatusForContentTemplates();
    if (!shouldEnableExitModalForContentTemplates) {
      console.debug('Disabling exit modal for Content template.');
      document.querySelector('.exit-modal-wrapper').remove();
      return;
    }
    console.debug('Leaving exit modal enabled for Content template based on existence of a query parameter.');
  }
  setupExitModal();
  if ('userAgentData' in navigator && navigator.userAgentData.mobile || 'maxTouchPoints' in navigator && navigator.maxTouchPoints > 0 || 'msMaxTouchPoints' in navigator && navigator.msMaxTouchPoints > 0 || (_matchMedia = matchMedia) !== null && _matchMedia !== void 0 && _matchMedia('(pointer:coarse)') && ((_matchMedia2 = matchMedia) === null || _matchMedia2 === void 0 || (_matchMedia2 = _matchMedia2('(pointer:coarse)')) === null || _matchMedia2 === void 0 ? void 0 : _matchMedia2.media) === '(pointer:coarse)' || 'orientation' in window || /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    var idleTimer = 0;
    ['touchstart', 'touchmove', 'click'].forEach(function (eventType) {
      return document.addEventListener(eventType, function () {
        return idleTimer = 0;
      });
    });
    setInterval(function () {
      var _sessionStorage2;
      idleTimer++;
      if (idleTimer >= 10 && !((_sessionStorage2 = sessionStorage) !== null && _sessionStorage2 !== void 0 && _sessionStorage2.getItem(EXIT_MODAL_DO_NOT_SHOW_SESSION_STORAGE_KEY)) && exitModalWrapper.classList.contains('hide-me')) {
        displayExitModal();
      }
    }, MOBILE_INACTIVITY_POLLING_MS);
  } else {
    document.addEventListener('mouseout', function (event) {
      if (!event.toElement && !event.relatedTarget) {
        setTimeout(function () {
          var _sessionStorage3;
          if (!checkIfExitModalShownCookieExists() && !((_sessionStorage3 = sessionStorage) !== null && _sessionStorage3 !== void 0 && _sessionStorage3.getItem(EXIT_MODAL_DO_NOT_SHOW_SESSION_STORAGE_KEY)) && exitModalWrapper.classList.contains('hide-me')) {
            displayExitModal();
          }
        }, DESKTOP_DELAY_MS);
      }
    });
  }
});
var initialColumnWidth;
function setRightRailStickyBehavior() {
  if (!document.querySelector('.right-rail')) {
    return;
  }
  var sidebarColumn = document.querySelector('.right-rail-full-column, .col-lg-4');
  if (!sidebarColumn) {
    return;
  }
  initialColumnWidth = Math.round(sidebarColumn.clientWidth);
  var bannerResizeObserver = new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      return adjustRightRailParentHeight(entry.target);
    });
  });
  var sidebarColumnsWithRightRail = Array.from(document.querySelectorAll('.right-rail-desktop'), function (rightRail) {
    return rightRail.parentElement;
  });
  sidebarColumnsWithRightRail.forEach(function (column) {
    bannerResizeObserver.observe(column);
    column.classList.add('right-rail-full-column');
  });
  var contentSectionsWithRightRail = Array.from(document.querySelectorAll('.middle-rail-full-column, .col-lg-8')).filter(function (contentSection) {
    return contentSection.nextElementSibling !== null && contentSection.nextElementSibling.classList.contains('right-rail-full-column');
  });
  sidebarColumnsWithRightRail.forEach(function (column) {
    window.addEventListener('scroll', function () {
      adjustRightRailParentHeight(column);
      var currentContentSection = [].find.call(contentSectionsWithRightRail, function (contentSection) {
        return isScrolledIntoView(contentSection);
      }) || contentSectionsWithRightRail[contentSectionsWithRightRail.length - 1];
      if (currentContentSection) {
        var rightRailForCurrentSection = currentContentSection.nextElementSibling;
        if (rightRailForCurrentSection.style.display === 'none') rightRailForCurrentSection.style.display = '';
        contentSectionsWithRightRail.forEach(function (contentSection) {
          if (contentSection.nextElementSibling.isEqualNode(rightRailForCurrentSection) || contentSection.nextElementSibling.style.display === 'none') return;
          contentSection.nextElementSibling.style.display = 'none';
        });
      }
    });
  });
}
function adjustRightRailParentHeight(sidebarColumn) {
  if (!sidebarColumn) {
    return;
  }
  if (sidebarColumn.textContent.trim().length <= 0) {
    return;
  }
  if (sidebarColumn.classList.contains('col-lg-3')) {
    return;
  }
  var columnWidth = Math.round(sidebarColumn.clientWidth);
  if (columnWidth <= 0) {
    return;
  }
  if (columnWidth <= initialColumnWidth && window.innerWidth <= 991) {
    sidebarColumn.classList.add('remove-dynamic-min-height-mobile');
    sidebarColumn.style.removeProperty('min-height');
  } else {
    sidebarColumn.classList.remove('remove-dynamic-min-height-mobile');
    var mainColumn = sidebarColumn.closest('.flex-row, .row').querySelector('.col-lg-8');
    if (mainColumn != null) {
      sidebarColumn.style.minHeight = mainColumn.clientHeight + 'px';
    }
  }
  initialColumnWidth = columnWidth;
}
function isScrolledIntoView(element) {
  if (!element) {
    return false;
  }
  var boundingClientRectangle = element.getBoundingClientRect();
  var subnavMenu = document.querySelector('.subnav-menu');
  var offset = subnavMenu ? subnavMenu.clientHeight : 0;
  var isVisible = boundingClientRectangle.bottom - offset >= 0;
  return isVisible;
}
function randomizeRightRailBannerVariant() {
  if (typeof RIGHT_RAIL_VARIANTS === 'undefined' || !RIGHT_RAIL_VARIANTS || RIGHT_RAIL_VARIANTS.length <= 1) {
    return;
  }
  var randomVariant = RIGHT_RAIL_VARIANTS[Math.floor(Math.random() * RIGHT_RAIL_VARIANTS.length)];
  var rightRailBanners = document.querySelectorAll('.right-rail-banner');
  rightRailBanners.forEach(function (rightRailBanner) {
    var rightRailTitle = rightRailBanner.querySelector('.right-rail-title');
    if (rightRailTitle) {
      rightRailTitle.textContent = randomVariant['right_rail_title'];
    }
    var rightRailText = rightRailBanner.querySelector('.right-rail-text');
    if (rightRailText) {
      rightRailText.textContent = randomVariant['right_rail_copy'];
    }
    var rightRailCitation = rightRailBanner.querySelector('.right-rail-citation');
    if (rightRailCitation) {
      rightRailCitation.textContent = randomVariant['right_rail_citation'];
    }
    var rightRailCta = rightRailBanner.querySelector('.right-rail-btn');
    if (rightRailCta) {
      rightRailCta.textContent = randomVariant['right_rail_cta_text'];
      rightRailCta.href = randomVariant['right_rail_cta_link'];
    }
    rightRailBanner.style = randomVariant['right_rail_background_inline_style'];
    currentVariantId = "".concat(TEMPLATE_SLUG, "--").concat(randomVariant["right_rail_variant_id"]);
  });
}
window.addEventListener('DOMContentLoaded', function () {
  randomizeRightRailBannerVariant();
});
var minimumNumberOfHeadings = 4;
function expandTableOfContents(navLinks, tablesOfContents) {
  navLinks.forEach(function (navLink) {
    navLink.style.height = "".concat(navLinks.scrollHeight, "px");
    navLink.style.maxHeight = 'fit-content';
    navLink.classList.add('expand-toc');
  });
  tablesOfContents.forEach(function (tableOfContents) {
    tableOfContents.classList.add('expand-toc');
    var toggleButton = tableOfContents.querySelector('.toggle-toc-button');
    if (toggleButton) {
      toggleButton.setAttribute('aria-expanded', 'true');
    }
  });
  makeTableOfContentsScrollableIfNeeded();
}
var needsScroll = false;
function makeTableOfContentsScrollableIfNeeded() {
  var desktopTableOfContents = document.querySelectorAll('.table-of-contents.toc-desktop');
  var desktopNavLinks = document.querySelectorAll('.table-of-contents.toc-desktop .nav-links-wrapper');
  var paddingOffset = 200;
  var fullNavHeight = desktopNavLinks[0].querySelector('li').offsetHeight * desktopNavLinks[0].querySelector('.nav-links').childElementCount + paddingOffset;
  if (window.innerWidth >= 992 && (needsScroll || desktopTableOfContents[0].clientHeight > window.innerHeight || fullNavHeight > window.innerHeight)) {
    desktopTableOfContents.forEach(function (toc) {
      toc.style.top = '5rem';
      toc.querySelector('.toggle-toc-button').style.paddingBottom = '0.5rem';
    });
    desktopNavLinks.forEach(function (navLink) {
      navLink.style.maxHeight = "".concat(window.innerHeight - 150, "px");
      navLink.style.overflowY = 'scroll';
    });
    needsScroll = true;
  } else {
    desktopTableOfContents.forEach(function (toc) {
      toc.style.removeProperty('top');
      toc.querySelector('.toggle-toc-button').style.removeProperty('padding-bottom');
    });
  }
}
function collapseTableOfContents(navLinks, tablesOfContents) {
  navLinks.forEach(function (navLink) {
    navLink.style.maxHeight = '0px';
    navLink.classList.remove('expand-toc');
  });
  tablesOfContents.forEach(function (tableOfContent) {
    tableOfContent.classList.remove('expand-toc');
    tableOfContent.style.removeProperty('top');
    var toggleButton = tableOfContent.querySelector('.toggle-toc-button');
    if (toggleButton) {
      toggleButton.setAttribute('aria-expanded', 'false');
      toggleButton.style.removeProperty('padding-bottom');
    }
  });
}
function toggleTableOfContents() {
  var navLinks = document.querySelectorAll('.table-of-contents .nav-links-wrapper');
  var tableOfContents = document.querySelectorAll('.table-of-contents');
  if (navLinks[0].style.maxHeight && navLinks[0].style.maxHeight !== '0px') {
    collapseTableOfContents(navLinks, tableOfContents);
  } else {
    expandTableOfContents(navLinks, tableOfContents);
  }
}
function getArticleHeadings() {
  var articleContentH2HeadingsSelector = 'main .middle-rail-full-column h2, .alphaposts-heading h2';
  var articleContentH2AndH3HeadingsSelector = 'main .middle-rail-full-column h2, .alphaposts-heading h2, main .middle-rail-full-column:not(.linking-widget-title) > h3';
  var nonEmptyH2Headings = Array.from(document.querySelectorAll(articleContentH2HeadingsSelector)).filter(function (element) {
    return element.innerText !== '' && element.innerHTML !== '&nbsp;';
  }).filter(function (element) {
    return !element.classList.contains('no-toc');
  });
  var nonEmptyH2AndH3Headings = Array.from(document.querySelectorAll(articleContentH2AndH3HeadingsSelector)).filter(function (element) {
    return element.innerText !== '' && element.innerHTML !== '&nbsp;';
  }).filter(function (element) {
    return !element.classList.contains('no-toc');
  });
  var nonEmptyHeadings = nonEmptyH2Headings;
  if (nonEmptyHeadings.length < minimumNumberOfHeadings) {
    nonEmptyHeadings = nonEmptyH2AndH3Headings;
  }
  return nonEmptyHeadings;
}
function addHeadingsToTableOfContents(nonEmptyHeadings) {
  var tableOfContentNavLinks = document.querySelectorAll('.table-of-contents .nav-links');
  nonEmptyHeadings.forEach(function (heading, index) {
    var headingLevel = 'main-heading';
    var contentHTML = "<li class=\"".concat(headingLevel, "\"><a href=\"#toc-jumpto-").concat(index, "\">").concat(heading.innerText, "</a></li>");
    heading.setAttribute('id', 'toc-jumpto-' + index);
    tableOfContentNavLinks.forEach(function (toc) {
      toc.insertAdjacentHTML('beforeend', contentHTML);
    });
  });
}
function setupTableOfContentsFocusBehavior() {
  var currentFocusElement = null;
  document.addEventListener('focus', function (event) {
    previousFocusElement = currentFocusElement;
    currentFocusElement = event.target;
  }, true);
}
function setupToggleClickHandlers() {
  document.querySelectorAll('.toggle-toc-button').forEach(function (toggle) {
    if (toggle) {
      toggle.addEventListener('click', function () {
        return toggleTableOfContents();
      });
    }
  });
  var navLinkWrappers = document.querySelectorAll('.nav-links-wrapper');
  document.querySelectorAll('.table-of-contents .see-more-button').forEach(function (seeMoreButton) {
    seeMoreButton.addEventListener('click', function () {
      navLinkWrappers.forEach(function (navLinkWrapper) {
        navLinkWrapper.classList.add('show-more-links');
        navLinkWrapper.classList.remove('show-less-links');
      });
      makeTableOfContentsScrollableIfNeeded();
      previousFocusElement.focus();
    });
  });
  document.querySelectorAll('.table-of-contents .see-less-button').forEach(function (seeLessButton) {
    seeLessButton.addEventListener('click', function () {
      navLinkWrappers.forEach(function (navLinkWrapper) {
        navLinkWrapper.classList.add('show-less-links');
        navLinkWrapper.classList.remove('show-more-links');
      });
      makeTableOfContentsScrollableIfNeeded();
      seeLessButton.parentElement.querySelector('.see-more-button').focus();
    });
  });
}
function setupAnchorScrollBehavior() {
  var navLinksItems = document.querySelectorAll(".nav-links a");
  navLinksItems.forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      var _iterator8 = _createForOfIteratorHelper(navLinksItems),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var link = _step8.value;
          link.classList.remove('active');
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      document.querySelectorAll('a[href="' + anchor.getAttribute('href') + '"]').forEach(function (navItem) {
        return navItem.classList.add('active');
      });
      var topOfElement = document.querySelector(anchor.getAttribute('href')).getBoundingClientRect().top + window.scrollY - 150;
      window.scroll({
        top: topOfElement,
        behavior: 'smooth'
      });
    });
  });
}
var _IsScrolledIntoView = typeof isScrolledIntoView != 'undefined' ? isScrolledIntoView : function (element) {
  if (!element) {
    return false;
  }
  var boundingClientRectangle = element.getBoundingClientRect();
  var subnavMenu = document.querySelector('.subnav-menu');
  var offset = subnavMenu ? subnavMenu.clientHeight : 0;
  var isVisible = boundingClientRectangle.bottom - offset >= 0;
  return isVisible;
};
function setupTableOfContentsJumpBehavior() {
  var contentSectionsWithToC = Array.from(document.querySelectorAll('.middle-rail-full-column')).filter(function (contentSection) {
    return contentSection.previousElementSibling !== null && contentSection.previousElementSibling.classList.contains('left-rail-full-column');
  });
  contentSectionsWithToC.forEach(function (column) {
    window.addEventListener('scroll', function () {
      var currentContentSection = [].find.call(contentSectionsWithToC, function (contentSection) {
        return _IsScrolledIntoView(contentSection);
      }) || contentSectionsWithToC[contentSectionsWithToC.length - 1];
      if (currentContentSection) {
        var toCElementForCurrentSection = currentContentSection.previousElementSibling.querySelector('.table-of-contents');
        if (toCElementForCurrentSection.style.display === 'none') toCElementForCurrentSection.style.display = '';
        contentSectionsWithToC.forEach(function (contentSection) {
          var toCElementForSection = contentSection.previousElementSibling.querySelector('.table-of-contents');
          if (toCElementForSection === toCElementForCurrentSection || toCElementForSection.style.display === 'none') return;
          toCElementForSection.style.display = 'none';
        });
      }
    });
  });
}
function conditionallyRenderSeeMoreLessButtons() {
  var links = document.querySelector('.nav-links');
  if (!links || links.childElementCount > 4) {
    return;
  }
  document.querySelectorAll('.table-of-contents .see-more-button, .table-of-contents .see-less-button').forEach(function (button) {
    return button.style.display = 'none';
  });
}
function maybeMoveInlineTableOfContentsUnderWistiaVideo() {
  if (document.querySelector('#video_script')) {
    return;
  }
  var wistiaVideoWrapper = document.querySelector('.middle-rail-full-column > .wistia_responsive_padding');
  var inlineTableOfContents = document.querySelector('.table-of-contents.toc-mobile');
  if (!wistiaVideoWrapper || !inlineTableOfContents) {
    return;
  }
  wistiaVideoWrapper.insertAdjacentElement('afterend', inlineTableOfContents.cloneNode(true));
  inlineTableOfContents.parentNode.removeChild(inlineTableOfContents);
}
function setupTableOfContents() {
  if (!document.querySelector('.table-of-contents') || document.querySelector('.table-of-contents.optTOC')) {
    return;
  }
  var nonEmptyHeadings = getArticleHeadings();
  if (!nonEmptyHeadings || nonEmptyHeadings.length < minimumNumberOfHeadings) {
    document.querySelectorAll('.table-of-contents').forEach(function (toc) {
      return toc.style.display = 'none';
    });
    return;
  }
  maybeMoveInlineTableOfContentsUnderWistiaVideo();
  addHeadingsToTableOfContents(nonEmptyHeadings);
  conditionallyRenderSeeMoreLessButtons();
  setupToggleClickHandlers();
  setupAnchorScrollBehavior();
  setupTableOfContentsJumpBehavior();
  setupTableOfContentsFocusBehavior();
  if (window.innerWidth >= 992) {
    var tableOfContents = document.querySelectorAll('.table-of-contents');
    var navLinks = document.querySelectorAll('.table-of-contents .nav-links-wrapper');
    expandTableOfContents(navLinks, tableOfContents);
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 992) {
        expandTableOfContents(navLinks, tableOfContents);
      } else {
        collapseTableOfContents(navLinks, tableOfContents);
      }
    });
  }
}
var previousFocusElement = null;
window.addEventListener('DOMContentLoaded', function (event) {
  setupTableOfContents();
});
var setupFaqEventListeners = function setupFaqEventListeners() {
  var qaEntries = document.querySelectorAll('.xds-faq-question-btn');
  if (!qaEntries) {
    return;
  }
  qaEntries.forEach(function (qaEntry) {
    var answerDiv = qaEntry.nextElementSibling;
    var focusableElements = answerDiv.querySelectorAll('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
    focusableElements.forEach(function (el) {
      if (el.hasAttribute('tabindex')) {
        el.setAttribute('data-original-tabindex', el.getAttribute('tabindex'));
      }
      el.setAttribute('tabindex', '-1');
    });
    qaEntry.addEventListener('click', function () {
      qaEntry.classList.toggle('active');
      var isHidden = answerDiv.getAttribute('aria-hidden') != 'true';
      answerDiv.setAttribute('aria-hidden', isHidden);
      var focusableElements = answerDiv.querySelectorAll('a, button, input, textarea, select, [data-original-tabindex]');
      focusableElements.forEach(function (el) {
        if (isHidden) {
          el.setAttribute('tabindex', '-1');
        } else {
          if (el.hasAttribute('data-original-tabindex')) {
            el.setAttribute('tabindex', el.getAttribute('data-original-tabindex'));
          } else {
            el.removeAttribute('tabindex');
          }
        }
      });
    });
  });
};
window.addEventListener('DOMContentLoaded', setupFaqEventListeners);
function shouldHideArticleDate() {
  var excludedPaths = ['/howtohub/', '/lead/'];
  for (var _i = 0, _excludedPaths = excludedPaths; _i < _excludedPaths.length; _i++) {
    var excludedPath = _excludedPaths[_i];
    if (window.location.pathname.includes(excludedPath)) {
      return false;
    }
  }
  var now = new Date();
  var oneYearAgo = new Date();
  oneYearAgo.setFullYear(now.getFullYear() - 1);
  if (typeof localized_computed_date !== "undefined") {
    var last_modified_date = new Date(localized_computed_date);
    if (last_modified_date < oneYearAgo) {
      return true;
    }
  }
  return false;
}
function updateDateModifiedFieldInGooglePageScheme() {
  var scriptTag = document.getElementById("google-page-scheme");
  if (scriptTag) {
    var jsonLd = JSON.parse(scriptTag.textContent);
    jsonLd.dateModified = new Date(localized_computed_date).toISOString();
    scriptTag.textContent = JSON.stringify(jsonLd, null, 2);
  }
}
document.addEventListener('DOMContentLoaded', function () {
  var localized_computed_date_changed = false;
  if (typeof localized_computed_date !== "undefined") {
    var radDateSelectors = ['x-indeed-hi-public[data-param="from_date"]', 'x-indeed-adh[data-param="local_date_of_data"]'];
    for (var _i2 = 0, _radDateSelectors = radDateSelectors; _i2 < _radDateSelectors.length; _i2++) {
      var radDateSelector = _radDateSelectors[_i2];
      var _iterator9 = _createForOfIteratorHelper(document.querySelectorAll(radDateSelector)),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var radDateTag = _step9.value;
          var radDate = new Date(radDateTag.textContent);
          if (radDate instanceof Date && !isNaN(radDate) && new Date(localized_computed_date) < radDate) {
            localized_computed_date = radDateTag.textContent;
            localized_computed_date_changed = true;
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    }
  }
  if (localized_computed_date_changed) {
    updateDateModifiedFieldInGooglePageScheme();
  }
  if (shouldHideArticleDate()) {
    var googlePageSchemeElement = document.querySelector("script[id='google-page-scheme']");
    if (googlePageSchemeElement) {
      googlePageSchemeElement.remove();
    }
    document.querySelectorAll(".xds-article-date.js").forEach(function (el) {
      var disclaimer = el.getAttribute('data-disclaimer');
      if (disclaimer) {
        el.textContent = disclaimer;
        el.classList.add('xds-article-date--disclaimer');
        el.style.display = '';
      }
    });
  } else {
    var articleDateElementJs = document.querySelector(".xds-article-date.js");
    if (articleDateElementJs) {
      articleDateElementJs.style.display = 'block';
    }
  }
});
document.addEventListener("DOMContentLoaded", function () {
  function toggleMission(event) {
    var _button$closest;
    var button = event.currentTarget;
    var missionText = (_button$closest = button.closest('.mission-statement-container')) === null || _button$closest === void 0 ? void 0 : _button$closest.querySelector('.mission-statement');
    var chevronIcon = button.querySelector('.mission-statement__chevron');
    if (!missionText) return;
    missionText.classList.toggle('mission-statement--expanded');
    if (chevronIcon) chevronIcon.classList.toggle('rotate');
  }
  document.querySelectorAll('.mission-statement__toggle-button').forEach(function (button) {
    button.addEventListener('click', toggleMission);
    button.addEventListener('touchstart', function (event) {
      event.preventDefault();
      toggleMission(event);
    });
  });
});

/*!
* tabbable 6.2.0
* @license MIT, https:
*/
(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, function () {
    var current = global.tabbable;
    var exports = global.tabbable = {};
    factory(exports);
    exports.noConflict = function () {
      global.tabbable = current;
      return exports;
    };
  }());
})(void 0, function (exports) {
  'use strict';

  var candidateSelectors = ['input:not([inert])', 'select:not([inert])', 'textarea:not([inert])', 'a[href]:not([inert])', 'button:not([inert])', '[tabindex]:not(slot):not([inert])', 'audio[controls]:not([inert])', 'video[controls]:not([inert])', '[contenteditable]:not([contenteditable="false"]):not([inert])', 'details>summary:first-of-type:not([inert])', 'details:not([inert])'];
  var candidateSelector = candidateSelectors.join(',');
  var NoElement = typeof Element === 'undefined';
  var matches = NoElement ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  var getRootNode = !NoElement && Element.prototype.getRootNode ? function (element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
  } : function (element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
  };
  var isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) {
      lookUp = true;
    }
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    var result = inert || lookUp && node && isInert(node.parentNode);
    return result;
  };
  var isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
  };
  var getCandidates = function getCandidates(el, includeContainer, filter) {
    if (isInert(el)) {
      return [];
    }
    var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
    if (includeContainer && matches.call(el, candidateSelector)) {
      candidates.unshift(el);
    }
    candidates = candidates.filter(filter);
    return candidates;
  };
  var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while (elementsToCheck.length) {
      var element = elementsToCheck.shift();
      if (isInert(element, false)) {
        continue;
      }
      if (element.tagName === 'SLOT') {
        var assigned = element.assignedElements();
        var content = assigned.length ? assigned : element.children;
        var nestedCandidates = getCandidatesIteratively(content, true, options);
        if (options.flatten) {
          candidates.push.apply(candidates, nestedCandidates);
        } else {
          candidates.push({
            scopeParent: element,
            candidates: nestedCandidates
          });
        }
      } else {
        var validCandidate = matches.call(element, candidateSelector);
        if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
          candidates.push(element);
        }
        var shadowRoot = element.shadowRoot || typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
        var validShadowRoot = !isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
        if (shadowRoot && validShadowRoot) {
          var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
          if (options.flatten) {
            candidates.push.apply(candidates, _nestedCandidates);
          } else {
            candidates.push({
              scopeParent: element,
              candidates: _nestedCandidates
            });
          }
        } else {
          elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
      }
    }
    return candidates;
  };
  var hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
  };
  var getTabIndex = function getTabIndex(node) {
    if (!node) {
      throw new Error('No node provided');
    }
    if (node.tabIndex < 0) {
      if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && !hasTabIndex(node)) {
        return 0;
      }
    }
    return node.tabIndex;
  };
  var getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = getTabIndex(node);
    if (tabIndex < 0 && isScope && !hasTabIndex(node)) {
      return 0;
    }
    return tabIndex;
  };
  var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
  };
  var isInput = function isInput(node) {
    return node.tagName === 'INPUT';
  };
  var isHiddenInput = function isHiddenInput(node) {
    return isInput(node) && node.type === 'hidden';
  };
  var isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
      return child.tagName === 'SUMMARY';
    });
    return r;
  };
  var getCheckedRadio = function getCheckedRadio(nodes, form) {
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].checked && nodes[i].form === form) {
        return nodes[i];
      }
    }
  };
  var isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) {
      return true;
    }
    var radioScope = node.form || getRootNode(node);
    var queryRadios = function queryRadios(name) {
      return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
      radioSet = queryRadios(window.CSS.escape(node.name));
    } else {
      try {
        radioSet = queryRadios(node.name);
      } catch (err) {
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
      }
    }
    var checked = getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
  };
  var isRadio = function isRadio(node) {
    return isInput(node) && node.type === 'radio';
  };
  var isNonTabbableRadio = function isNonTabbableRadio(node) {
    return isRadio(node) && !isTabbableRadio(node);
  };
  var isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    var nodeRoot = node && getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
      var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
      attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
      while (!attached && nodeRootHost) {
        var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
        nodeRoot = getRootNode(nodeRootHost);
        nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
        attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
      }
    }
    return attached;
  };
  var isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(),
      width = _node$getBoundingClie.width,
      height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
  };
  var isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck,
      getShadowRoot = _ref.getShadowRoot;
    if (getComputedStyle(node).visibility === 'hidden') {
      return true;
    }
    var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
      return true;
    }
    if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
      if (typeof getShadowRoot === 'function') {
        var originalNode = node;
        while (node) {
          var parentElement = node.parentElement;
          var rootNode = getRootNode(node);
          if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true) {
            return isZeroArea(node);
          } else if (node.assignedSlot) {
            node = node.assignedSlot;
          } else if (!parentElement && rootNode !== node.ownerDocument) {
            node = rootNode.host;
          } else {
            node = parentElement;
          }
        }
        node = originalNode;
      }
      if (isNodeAttached(node)) {
        return !node.getClientRects().length;
      }
      if (displayCheck !== 'legacy-full') {
        return true;
      }
    } else if (displayCheck === 'non-zero-area') {
      return isZeroArea(node);
    }
    return false;
  };
  var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
      var parentNode = node.parentElement;
      while (parentNode) {
        if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
          for (var i = 0; i < parentNode.children.length; i++) {
            var child = parentNode.children.item(i);
            if (child.tagName === 'LEGEND') {
              return matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
            }
          }
          return true;
        }
        parentNode = parentNode.parentElement;
      }
    }
    return false;
  };
  var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || isInert(node) || isHiddenInput(node) || isHidden(node, options) || isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
      return false;
    }
    return true;
  };
  var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if (isNonTabbableRadio(node) || getTabIndex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
      return false;
    }
    return true;
  };
  var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) {
      return true;
    }
    return false;
  };
  var sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function (item, i) {
      var isScope = !!item.scopeParent;
      var element = isScope ? item.scopeParent : item;
      var candidateTabindex = getSortOrderTabIndex(element, isScope);
      var elements = isScope ? sortByOrder(item.candidates) : element;
      if (candidateTabindex === 0) {
        isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
      } else {
        orderedTabbables.push({
          documentOrder: i,
          tabIndex: candidateTabindex,
          item: item,
          isScope: isScope,
          content: elements
        });
      }
    });
    return orderedTabbables.sort(sortOrderedTabbables).reduce(function (acc, sortable) {
      sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
      return acc;
    }, []).concat(regularTabbables);
  };
  var tabbable = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) {
      candidates = getCandidatesIteratively([container], options.includeContainer, {
        filter: isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: isValidShadowRootTabbable
      });
    } else {
      candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
    }
    return sortByOrder(candidates);
  };
  var focusable = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) {
      candidates = getCandidatesIteratively([container], options.includeContainer, {
        filter: isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
      });
    } else {
      candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
    }
    return candidates;
  };
  var isTabbable = function isTabbable(node, options) {
    options = options || {};
    if (!node) {
      throw new Error('No node provided');
    }
    if (matches.call(node, candidateSelector) === false) {
      return false;
    }
    return isNodeMatchingSelectorTabbable(options, node);
  };
  var focusableCandidateSelector = candidateSelectors.concat('iframe').join(',');
  var isFocusable = function isFocusable(node, options) {
    options = options || {};
    if (!node) {
      throw new Error('No node provided');
    }
    if (matches.call(node, focusableCandidateSelector) === false) {
      return false;
    }
    return isNodeMatchingSelectorFocusable(options, node);
  };
  exports.focusable = focusable;
  exports.getTabIndex = getTabIndex;
  exports.isFocusable = isFocusable;
  exports.isTabbable = isTabbable;
  exports.tabbable = tabbable;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});

/*!
* focus-trap 7.6.4
* @license MIT, https:
*/
(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports, require('tabbable')) : typeof define === 'function' && define.amd ? define(['exports', 'tabbable'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, function () {
    var current = global.focusTrap;
    var exports = global.focusTrap = {};
    factory(exports, global.tabbable);
    exports.noConflict = function () {
      global.focusTrap = current;
      return exports;
    };
  }());
})(void 0, function (exports, tabbable) {
  'use strict';

  function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
    return n;
  }
  function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) return _arrayLikeToArray(r);
  }
  function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: true,
      configurable: true,
      writable: true
    }) : e[r] = t, e;
  }
  function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
  }
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      r && (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })), t.push.apply(t, o);
    }
    return t;
  }
  function _objectSpread2(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? ownKeys(Object(t), true).forEach(function (r) {
        _defineProperty(e, r, t[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
      });
    }
    return e;
  }
  function _toConsumableArray(r) {
    return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
  }
  function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (undefined !== e) {
      var i = e.call(t, r || "default");
      if ("object" != _typeof(i)) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }
  function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
  }
  function _unsupportedIterableToArray(r, a) {
    if (r) {
      if ("string" == typeof r) return _arrayLikeToArray(r, a);
      var t = {}.toString.call(r).slice(8, -1);
      return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : undefined;
    }
  }
  var activeFocusTraps = {
    activateTrap: function activateTrap(trapStack, trap) {
      if (trapStack.length > 0) {
        var activeTrap = trapStack[trapStack.length - 1];
        if (activeTrap !== trap) {
          activeTrap._setPausedState(true);
        }
      }
      var trapIndex = trapStack.indexOf(trap);
      if (trapIndex === -1) {
        trapStack.push(trap);
      } else {
        trapStack.splice(trapIndex, 1);
        trapStack.push(trap);
      }
    },
    deactivateTrap: function deactivateTrap(trapStack, trap) {
      var trapIndex = trapStack.indexOf(trap);
      if (trapIndex !== -1) {
        trapStack.splice(trapIndex, 1);
      }
      if (trapStack.length > 0 && !trapStack[trapStack.length - 1]._isManuallyPaused()) {
        trapStack[trapStack.length - 1]._setPausedState(false);
      }
    }
  };
  var isSelectableInput = function isSelectableInput(node) {
    return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
  };
  var isEscapeEvent = function isEscapeEvent(e) {
    return (e === null || e === undefined ? undefined : e.key) === 'Escape' || (e === null || e === undefined ? undefined : e.key) === 'Esc' || (e === null || e === undefined ? undefined : e.keyCode) === 27;
  };
  var isTabEvent = function isTabEvent(e) {
    return (e === null || e === undefined ? undefined : e.key) === 'Tab' || (e === null || e === undefined ? undefined : e.keyCode) === 9;
  };
  var isKeyForward = function isKeyForward(e) {
    return isTabEvent(e) && !e.shiftKey;
  };
  var isKeyBackward = function isKeyBackward(e) {
    return isTabEvent(e) && e.shiftKey;
  };
  var delay = function delay(fn) {
    return setTimeout(fn, 0);
  };
  var valueOrHandler = function valueOrHandler(value) {
    for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }
    return typeof value === 'function' ? value.apply(undefined, params) : value;
  };
  var getActualTarget = function getActualTarget(event) {
    return event.target.shadowRoot && typeof event.composedPath === 'function' ? event.composedPath()[0] : event.target;
  };
  var internalTrapStack = [];
  var createFocusTrap = function createFocusTrap(elements, userOptions) {
    var doc = (userOptions === null || userOptions === undefined ? undefined : userOptions.document) || document;
    var trapStack = (userOptions === null || userOptions === undefined ? undefined : userOptions.trapStack) || internalTrapStack;
    var config = _objectSpread2({
      returnFocusOnDeactivate: true,
      escapeDeactivates: true,
      delayInitialFocus: true,
      isKeyForward: isKeyForward,
      isKeyBackward: isKeyBackward
    }, userOptions);
    var state = {
      containers: [],
      containerGroups: [],
      tabbableGroups: [],
      nodeFocusedBeforeActivation: null,
      mostRecentlyFocusedNode: null,
      active: false,
      paused: false,
      manuallyPaused: false,
      delayInitialFocusTimer: undefined,
      recentNavEvent: undefined
    };
    var trap;
    var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
      return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    var findContainerIndex = function findContainerIndex(element, event) {
      var composedPath = typeof (event === null || event === undefined ? undefined : event.composedPath) === 'function' ? event.composedPath() : undefined;
      return state.containerGroups.findIndex(function (_ref) {
        var container = _ref.container,
          tabbableNodes = _ref.tabbableNodes;
        return container.contains(element) || (composedPath === null || composedPath === undefined ? undefined : composedPath.includes(container)) || tabbableNodes.find(function (node) {
          return node === element;
        });
      });
    };
    var getNodeForOption = function getNodeForOption(optionName) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$hasFallback = _ref2.hasFallback,
        hasFallback = _ref2$hasFallback === undefined ? false : _ref2$hasFallback,
        _ref2$params = _ref2.params,
        params = _ref2$params === undefined ? [] : _ref2$params;
      var optionValue = config[optionName];
      if (typeof optionValue === 'function') {
        optionValue = optionValue.apply(undefined, _toConsumableArray(params));
      }
      if (optionValue === true) {
        optionValue = undefined;
      }
      if (!optionValue) {
        if (optionValue === undefined || optionValue === false) {
          return optionValue;
        }
        throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
      }
      var node = optionValue;
      if (typeof optionValue === 'string') {
        try {
          node = doc.querySelector(optionValue);
        } catch (err) {
          throw new Error("`".concat(optionName, "` appears to be an invalid selector; error=\"").concat(err.message, "\""));
        }
        if (!node) {
          if (!hasFallback) {
            throw new Error("`".concat(optionName, "` as selector refers to no known node"));
          }
        }
      }
      return node;
    };
    var getInitialFocusNode = function getInitialFocusNode() {
      var node = getNodeForOption('initialFocus', {
        hasFallback: true
      });
      if (node === false) {
        return false;
      }
      if (node === undefined || node && !tabbable.isFocusable(node, config.tabbableOptions)) {
        if (findContainerIndex(doc.activeElement) >= 0) {
          node = doc.activeElement;
        } else {
          var firstTabbableGroup = state.tabbableGroups[0];
          var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
          node = firstTabbableNode || getNodeForOption('fallbackFocus');
        }
      } else if (node === null) {
        node = getNodeForOption('fallbackFocus');
      }
      if (!node) {
        throw new Error('Your focus-trap needs to have at least one focusable element');
      }
      return node;
    };
    var updateTabbableNodes = function updateTabbableNodes() {
      state.containerGroups = state.containers.map(function (container) {
        var tabbableNodes = tabbable.tabbable(container, config.tabbableOptions);
        var focusableNodes = tabbable.focusable(container, config.tabbableOptions);
        var firstTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[0] : undefined;
        var lastTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : undefined;
        var firstDomTabbableNode = focusableNodes.find(function (node) {
          return tabbable.isTabbable(node);
        });
        var lastDomTabbableNode = focusableNodes.slice().reverse().find(function (node) {
          return tabbable.isTabbable(node);
        });
        var posTabIndexesFound = !!tabbableNodes.find(function (node) {
          return tabbable.getTabIndex(node) > 0;
        });
        return {
          container: container,
          tabbableNodes: tabbableNodes,
          focusableNodes: focusableNodes,
          posTabIndexesFound: posTabIndexesFound,
          firstTabbableNode: firstTabbableNode,
          lastTabbableNode: lastTabbableNode,
          firstDomTabbableNode: firstDomTabbableNode,
          lastDomTabbableNode: lastDomTabbableNode,
          nextTabbableNode: function nextTabbableNode(node) {
            var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var nodeIdx = tabbableNodes.indexOf(node);
            if (nodeIdx < 0) {
              if (forward) {
                return focusableNodes.slice(focusableNodes.indexOf(node) + 1).find(function (el) {
                  return tabbable.isTabbable(el);
                });
              }
              return focusableNodes.slice(0, focusableNodes.indexOf(node)).reverse().find(function (el) {
                return tabbable.isTabbable(el);
              });
            }
            return tabbableNodes[nodeIdx + (forward ? 1 : -1)];
          }
        };
      });
      state.tabbableGroups = state.containerGroups.filter(function (group) {
        return group.tabbableNodes.length > 0;
      });
      if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus')) {
        throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
      }
      if (state.containerGroups.find(function (g) {
        return g.posTabIndexesFound;
      }) && state.containerGroups.length > 1) {
        throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
      }
    };
    var _getActiveElement = function getActiveElement(el) {
      var activeElement = el.activeElement;
      if (!activeElement) {
        return;
      }
      if (activeElement.shadowRoot && activeElement.shadowRoot.activeElement !== null) {
        return _getActiveElement(activeElement.shadowRoot);
      }
      return activeElement;
    };
    var _tryFocus = function tryFocus(node) {
      if (node === false) {
        return;
      }
      if (node === _getActiveElement(document)) {
        return;
      }
      if (!node || !node.focus) {
        _tryFocus(getInitialFocusNode());
        return;
      }
      node.focus({
        preventScroll: !!config.preventScroll
      });
      state.mostRecentlyFocusedNode = node;
      if (isSelectableInput(node)) {
        node.select();
      }
    };
    var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
      var node = getNodeForOption('setReturnFocus', {
        params: [previousActiveElement]
      });
      return node ? node : node === false ? false : previousActiveElement;
    };
    var findNextNavNode = function findNextNavNode(_ref3) {
      var target = _ref3.target,
        event = _ref3.event,
        _ref3$isBackward = _ref3.isBackward,
        isBackward = _ref3$isBackward === undefined ? false : _ref3$isBackward;
      target = target || getActualTarget(event);
      updateTabbableNodes();
      var destinationNode = null;
      if (state.tabbableGroups.length > 0) {
        var containerIndex = findContainerIndex(target, event);
        var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;
        if (containerIndex < 0) {
          if (isBackward) {
            destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
          } else {
            destinationNode = state.tabbableGroups[0].firstTabbableNode;
          }
        } else if (isBackward) {
          var startOfGroupIndex = state.tabbableGroups.findIndex(function (_ref4) {
            var firstTabbableNode = _ref4.firstTabbableNode;
            return target === firstTabbableNode;
          });
          if (startOfGroupIndex < 0 && (containerGroup.container === target || tabbable.isFocusable(target, config.tabbableOptions) && !tabbable.isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) {
            startOfGroupIndex = containerIndex;
          }
          if (startOfGroupIndex >= 0) {
            var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
            var destinationGroup = state.tabbableGroups[destinationGroupIndex];
            destinationNode = tabbable.getTabIndex(target) >= 0 ? destinationGroup.lastTabbableNode : destinationGroup.lastDomTabbableNode;
          } else if (!isTabEvent(event)) {
            destinationNode = containerGroup.nextTabbableNode(target, false);
          }
        } else {
          var lastOfGroupIndex = state.tabbableGroups.findIndex(function (_ref5) {
            var lastTabbableNode = _ref5.lastTabbableNode;
            return target === lastTabbableNode;
          });
          if (lastOfGroupIndex < 0 && (containerGroup.container === target || tabbable.isFocusable(target, config.tabbableOptions) && !tabbable.isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) {
            lastOfGroupIndex = containerIndex;
          }
          if (lastOfGroupIndex >= 0) {
            var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
            var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
            destinationNode = tabbable.getTabIndex(target) >= 0 ? _destinationGroup.firstTabbableNode : _destinationGroup.firstDomTabbableNode;
          } else if (!isTabEvent(event)) {
            destinationNode = containerGroup.nextTabbableNode(target);
          }
        }
      } else {
        destinationNode = getNodeForOption('fallbackFocus');
      }
      return destinationNode;
    };
    var checkPointerDown = function checkPointerDown(e) {
      var target = getActualTarget(e);
      if (findContainerIndex(target, e) >= 0) {
        return;
      }
      if (valueOrHandler(config.clickOutsideDeactivates, e)) {
        trap.deactivate({
          returnFocus: config.returnFocusOnDeactivate
        });
        return;
      }
      if (valueOrHandler(config.allowOutsideClick, e)) {
        return;
      }
      e.preventDefault();
    };
    var checkFocusIn = function checkFocusIn(event) {
      var target = getActualTarget(event);
      var targetContained = findContainerIndex(target, event) >= 0;
      if (targetContained || target instanceof Document) {
        if (targetContained) {
          state.mostRecentlyFocusedNode = target;
        }
      } else {
        event.stopImmediatePropagation();
        var nextNode;
        var navAcrossContainers = true;
        if (state.mostRecentlyFocusedNode) {
          if (tabbable.getTabIndex(state.mostRecentlyFocusedNode) > 0) {
            var mruContainerIdx = findContainerIndex(state.mostRecentlyFocusedNode);
            var tabbableNodes = state.containerGroups[mruContainerIdx].tabbableNodes;
            if (tabbableNodes.length > 0) {
              var mruTabIdx = tabbableNodes.findIndex(function (node) {
                return node === state.mostRecentlyFocusedNode;
              });
              if (mruTabIdx >= 0) {
                if (config.isKeyForward(state.recentNavEvent)) {
                  if (mruTabIdx + 1 < tabbableNodes.length) {
                    nextNode = tabbableNodes[mruTabIdx + 1];
                    navAcrossContainers = false;
                  }
                } else {
                  if (mruTabIdx - 1 >= 0) {
                    nextNode = tabbableNodes[mruTabIdx - 1];
                    navAcrossContainers = false;
                  }
                }
              }
            }
          } else {
            if (!state.containerGroups.some(function (g) {
              return g.tabbableNodes.some(function (n) {
                return tabbable.getTabIndex(n) > 0;
              });
            })) {
              navAcrossContainers = false;
            }
          }
        } else {
          navAcrossContainers = false;
        }
        if (navAcrossContainers) {
          nextNode = findNextNavNode({
            target: state.mostRecentlyFocusedNode,
            isBackward: config.isKeyBackward(state.recentNavEvent)
          });
        }
        if (nextNode) {
          _tryFocus(nextNode);
        } else {
          _tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
        }
      }
      state.recentNavEvent = undefined;
    };
    var checkKeyNav = function checkKeyNav(event) {
      var isBackward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      state.recentNavEvent = event;
      var destinationNode = findNextNavNode({
        event: event,
        isBackward: isBackward
      });
      if (destinationNode) {
        if (isTabEvent(event)) {
          event.preventDefault();
        }
        _tryFocus(destinationNode);
      }
    };
    var checkTabKey = function checkTabKey(event) {
      if (config.isKeyForward(event) || config.isKeyBackward(event)) {
        checkKeyNav(event, config.isKeyBackward(event));
      }
    };
    var checkEscapeKey = function checkEscapeKey(event) {
      if (isEscapeEvent(event) && valueOrHandler(config.escapeDeactivates, event) !== false) {
        event.preventDefault();
        trap.deactivate();
      }
    };
    var checkClick = function checkClick(e) {
      var target = getActualTarget(e);
      if (findContainerIndex(target, e) >= 0) {
        return;
      }
      if (valueOrHandler(config.clickOutsideDeactivates, e)) {
        return;
      }
      if (valueOrHandler(config.allowOutsideClick, e)) {
        return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
    };
    var addListeners = function addListeners() {
      if (!state.active) {
        return;
      }
      activeFocusTraps.activateTrap(trapStack, trap);
      state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function () {
        _tryFocus(getInitialFocusNode());
      }) : _tryFocus(getInitialFocusNode());
      doc.addEventListener('focusin', checkFocusIn, true);
      doc.addEventListener('mousedown', checkPointerDown, {
        capture: true,
        passive: false
      });
      doc.addEventListener('touchstart', checkPointerDown, {
        capture: true,
        passive: false
      });
      doc.addEventListener('click', checkClick, {
        capture: true,
        passive: false
      });
      doc.addEventListener('keydown', checkTabKey, {
        capture: true,
        passive: false
      });
      doc.addEventListener('keydown', checkEscapeKey);
      return trap;
    };
    var removeListeners = function removeListeners() {
      if (!state.active) {
        return;
      }
      doc.removeEventListener('focusin', checkFocusIn, true);
      doc.removeEventListener('mousedown', checkPointerDown, true);
      doc.removeEventListener('touchstart', checkPointerDown, true);
      doc.removeEventListener('click', checkClick, true);
      doc.removeEventListener('keydown', checkTabKey, true);
      doc.removeEventListener('keydown', checkEscapeKey);
      return trap;
    };
    var checkDomRemoval = function checkDomRemoval(mutations) {
      var isFocusedNodeRemoved = mutations.some(function (mutation) {
        var removedNodes = Array.from(mutation.removedNodes);
        return removedNodes.some(function (node) {
          return node === state.mostRecentlyFocusedNode;
        });
      });
      if (isFocusedNodeRemoved) {
        _tryFocus(getInitialFocusNode());
      }
    };
    var mutationObserver = typeof window !== 'undefined' && 'MutationObserver' in window ? new MutationObserver(checkDomRemoval) : undefined;
    var updateObservedNodes = function updateObservedNodes() {
      if (!mutationObserver) {
        return;
      }
      mutationObserver.disconnect();
      if (state.active && !state.paused) {
        state.containers.map(function (container) {
          mutationObserver.observe(container, {
            subtree: true,
            childList: true
          });
        });
      }
    };
    trap = {
      get active() {
        return state.active;
      },
      get paused() {
        return state.paused;
      },
      activate: function activate(activateOptions) {
        if (state.active) {
          return this;
        }
        var onActivate = getOption(activateOptions, 'onActivate');
        var onPostActivate = getOption(activateOptions, 'onPostActivate');
        var checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap');
        if (!checkCanFocusTrap) {
          updateTabbableNodes();
        }
        state.active = true;
        state.paused = false;
        state.nodeFocusedBeforeActivation = doc.activeElement;
        onActivate === null || onActivate === undefined || onActivate();
        var finishActivation = function finishActivation() {
          if (checkCanFocusTrap) {
            updateTabbableNodes();
          }
          addListeners();
          updateObservedNodes();
          onPostActivate === null || onPostActivate === undefined || onPostActivate();
        };
        if (checkCanFocusTrap) {
          checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
          return this;
        }
        finishActivation();
        return this;
      },
      deactivate: function deactivate(deactivateOptions) {
        if (!state.active) {
          return this;
        }
        var options = _objectSpread2({
          onDeactivate: config.onDeactivate,
          onPostDeactivate: config.onPostDeactivate,
          checkCanReturnFocus: config.checkCanReturnFocus
        }, deactivateOptions);
        clearTimeout(state.delayInitialFocusTimer);
        state.delayInitialFocusTimer = undefined;
        removeListeners();
        state.active = false;
        state.paused = false;
        updateObservedNodes();
        activeFocusTraps.deactivateTrap(trapStack, trap);
        var onDeactivate = getOption(options, 'onDeactivate');
        var onPostDeactivate = getOption(options, 'onPostDeactivate');
        var checkCanReturnFocus = getOption(options, 'checkCanReturnFocus');
        var returnFocus = getOption(options, 'returnFocus', 'returnFocusOnDeactivate');
        onDeactivate === null || onDeactivate === undefined || onDeactivate();
        var finishDeactivation = function finishDeactivation() {
          delay(function () {
            if (returnFocus) {
              _tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
            }
            onPostDeactivate === null || onPostDeactivate === undefined || onPostDeactivate();
          });
        };
        if (returnFocus && checkCanReturnFocus) {
          checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
          return this;
        }
        finishDeactivation();
        return this;
      },
      pause: function pause(pauseOptions) {
        if (!state.active) {
          return this;
        }
        state.manuallyPaused = true;
        return this._setPausedState(true, pauseOptions);
      },
      unpause: function unpause(unpauseOptions) {
        if (!state.active) {
          return this;
        }
        state.manuallyPaused = false;
        if (trapStack[trapStack.length - 1] !== this) {
          return this;
        }
        return this._setPausedState(false, unpauseOptions);
      },
      updateContainerElements: function updateContainerElements(containerElements) {
        var elementsAsArray = [].concat(containerElements).filter(Boolean);
        state.containers = elementsAsArray.map(function (element) {
          return typeof element === 'string' ? doc.querySelector(element) : element;
        });
        if (state.active) {
          updateTabbableNodes();
        }
        updateObservedNodes();
        return this;
      }
    };
    Object.defineProperties(trap, {
      _isManuallyPaused: {
        value: function value() {
          return state.manuallyPaused;
        }
      },
      _setPausedState: {
        value: function value(paused, options) {
          if (state.paused === paused) {
            return this;
          }
          state.paused = paused;
          if (paused) {
            var onPause = getOption(options, 'onPause');
            var onPostPause = getOption(options, 'onPostPause');
            onPause === null || onPause === undefined || onPause();
            removeListeners();
            updateObservedNodes();
            onPostPause === null || onPostPause === undefined || onPostPause();
          } else {
            var onUnpause = getOption(options, 'onUnpause');
            var onPostUnpause = getOption(options, 'onPostUnpause');
            onUnpause === null || onUnpause === undefined || onUnpause();
            updateTabbableNodes();
            addListeners();
            updateObservedNodes();
            onPostUnpause === null || onPostUnpause === undefined || onPostUnpause();
          }
          return this;
        }
      }
    });
    trap.updateContainerElements(elements);
    return trap;
  };
  exports.createFocusTrap = createFocusTrap;
});
document.addEventListener('DOMContentLoaded', function () {
  var lastFocusedElement = null;
  var focusTrapInstance = null;
  function showModal(editorsNoteLabel, termTitle, definition, links, linksLabel) {
    var modal = document.getElementById('editors-note-modal');
    var titleEl = document.getElementById('editors-note-modal-title');
    var contentEl = document.getElementById('editors-note-modal-content');
    if (!modal || !titleEl || !contentEl) {
      console.warn('Editor’s Note modal elements not found.');
      return;
    }
    if (!modal.hasAttribute('hidden')) {
      return;
    }
    lastFocusedElement = document.activeElement;
    titleEl.textContent = editorsNoteLabel;
    var contentHTML = "\n            <div class=\"editors-note-modal__wrapper\">\n                <span class=\"editors-note-modal-term-title\"><strong>".concat(termTitle, "</strong></span>\n                <p class=\"editors-note-modal-paragraph\">").concat(definition, "</p>\n            </div>\n        ");
    if (Array.isArray(links) && links.length > 0) {
      contentHTML += "<span class=\"editors-note-modal-links-label\"><strong>".concat(linksLabel, "</strong></span><ul>");
      links.forEach(function (linkObj) {
        if (_typeof(linkObj) === 'object' && linkObj.url && linkObj.title) {
          var url = String(linkObj.url).trim();
          var linkTitle = String(linkObj.title).trim();
          contentHTML += "\n                        <li class=\"editors-note-modal-link\">\n                            <a href=\"".concat(url, "\" target=\"_blank\" rel=\"noopener noreferrer\">").concat(linkTitle, "</a>\n                        </li>");
        } else {
          console.error("Invalid link object:", linkObj);
        }
      });
      contentHTML += '</ul>';
    }
    contentEl.innerHTML = contentHTML;
    modal.removeAttribute('hidden');
    modal.style.display = 'flex';
    modal.setAttribute('aria-hidden', 'false');
    if (window.focusTrap) {
      focusTrapInstance = window.focusTrap.createFocusTrap(modal, {
        escapeDeactivates: true,
        clickOutsideDeactivates: true,
        fallbackFocus: modal,
        initialFocus: modal
      });
      focusTrapInstance.activate();
    }
  }
  function hideModal() {
    var modal = document.getElementById('editors-note-modal');
    var contentEl = document.getElementById('editors-note-modal-content');
    if (!modal || modal.hasAttribute('hidden')) {
      return;
    }
    modal.setAttribute('hidden', true);
    modal.setAttribute('aria-hidden', 'true');
    modal.style.display = 'none';
    if (contentEl) {
      contentEl.innerHTML = '';
    }
    if (focusTrapInstance) {
      focusTrapInstance.deactivate();
      focusTrapInstance = null;
    }
    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
  }
  document.body.addEventListener('click', function (e) {
    var editorsNote = e.target.closest('.editors-note');
    if (editorsNote) {
      e.preventDefault();
      var definition = editorsNote.getAttribute('data-definition');
      var termTitle = editorsNote.textContent.trim();
      var editorsNoteLabel = editorsNote.getAttribute('data-editors-note') || "Editor's Note";
      var linksLabel = editorsNote.getAttribute('data-links-label') || "Related resources";
      var links = JSON.parse(editorsNote.getAttribute('data-links'));
      showModal(editorsNoteLabel, termTitle, definition, links, linksLabel);
    }
    if (e.target.matches('.editors-note-icon')) {
      e.preventDefault();
      var _editorsNote = e.target.previousElementSibling;
      if (_editorsNote && _editorsNote.classList.contains('editors-note')) {
        _editorsNote.click();
      }
    }
  });
  var closeBtn = document.getElementById('editors-note-close-modal');
  if (closeBtn) {
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      hideModal();
    });
  }
  window.addEventListener('click', function (e) {
    var modal = document.getElementById('editors-note-modal');
    if (!modal) return;
    var modalContent = modal.querySelector('.modal-content');
    if (e.target === modal && (!modalContent || !modalContent.contains(e.target))) {
      hideModal();
    }
  });
  window.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      hideModal();
    } else if (e.key === "Enter") {
      var editorsNote = e.target.closest('.editors-note');
      if (editorsNote) {
        e.preventDefault();
        editorsNote.click();
      }
    }
  });
});
function articleRecommendationCarousel() {
  var exampleBar = document.querySelector('#articleRecommendation');
  if (exampleBar == null) {
    return;
  }
  var itemList = exampleBar.querySelectorAll('.article-recommendation__carousel-slide');
  var numItems = itemList.length;
  var numCardsPerViewOnDesktop = Math.min(3, numItems);
  var numCardsPerViewOnTablet = Math.min(2, numItems);
  var numCardsPerViewOnMobile = Math.min(2, numItems);
  var swiperOptions = {
    init: false,
    slidesPerView: numCardsPerViewOnMobile,
    slidesPerGroup: numCardsPerViewOnMobile,
    spaceBetween: 48,
    observer: true,
    observeParents: true,
    slideToClickedSlide: true,
    simulateTouch: false,
    direction: 'horizontal',
    breakpoints: {
      992: {
        slidesPerView: numCardsPerViewOnDesktop,
        slidesPerGroup: numCardsPerViewOnDesktop
      },
      768: {
        slidesPerView: numCardsPerViewOnTablet,
        slidesPerGroup: numCardsPerViewOnTablet
      }
    },
    navigation: {
      nextEl: '.article-recommendation__carousel-change-page-right-btn',
      prevEl: '.article-recommendation__carousel-change-page-left-btn'
    }
  };
  var swiper = new Swiper('.swiper', swiperOptions);
  swiper.init();
}
function toggleDropdown(event) {
  var button = event.currentTarget;
  var recommendationList = button.closest('.article-recommendation-wrap').querySelector('.article-recommendation__list');
  var chevronIcon = button.querySelector('.article-recommendation__chevron');
  if (!recommendationList) return;
  recommendationList.classList.toggle('article-recommendation--expanded');
  recommendationList.classList.toggle('hide');
  if (chevronIcon) chevronIcon.classList.toggle('rotate');
}
function initalizeArticleRecommendationCarouselOnLoad() {
  articleRecommendationCarousel();
  document.querySelectorAll('.article-recommendation__toggle-button').forEach(function (button) {
    button.addEventListener('click', toggleDropdown);
    button.addEventListener('touchstart', function (event) {
      event.preventDefault();
      toggleDropdown(event);
    });
  });
}
window.addEventListener('DOMContentLoaded', initalizeArticleRecommendationCarouselOnLoad, {
  once: true
});
var ProgressBar = /*#__PURE__*/function () {
  function ProgressBar() {
    var _this$progressBarCont;
    _classCallCheck(this, ProgressBar);
    this.subcategoryMenu = document.getElementById("internal-component-smb-subcategory-menu");
    this.progressBarContainer = document.querySelector('.scroll-progress-container');
    this.progressBar = (_this$progressBarCont = this.progressBarContainer) === null || _this$progressBarCont === void 0 ? void 0 : _this$progressBarCont.querySelector(".scroll-progress-bar");
    if (!this.progressBar) {
      return;
    }
    this.updateProgress = this.updateProgress.bind(this);
    this.debouncedUpdateProgress = this.debounce(this.updateProgress, 10);
    this.handleResize = this.handleResize.bind(this);
    this.debouncedSetPosition = this.debounce(this.updatePosition.bind(this), 100);
    this.init();
  }
  return _createClass(ProgressBar, [{
    key: "debounce",
    value: function debounce(func, wait) {
      var timeout;
      return function executedFunction() {
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }
        var later = function later() {
          clearTimeout(timeout);
          func.apply(void 0, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }
  }, {
    key: "init",
    value: function init() {
      var _this3 = this;
      requestAnimationFrame(function () {
        _this3.updatePosition();
        _this3.setupEventListeners();
        _this3.updateProgress();
      });
    }
  }, {
    key: "updatePosition",
    value: function updatePosition() {
      if (this.subcategoryMenu && this.progressBarContainer) {
        var currentHeight = this.subcategoryMenu.offsetHeight;
        var newTopValue = currentHeight + 'px';
        var currentTopValue = this.progressBarContainer.style.getPropertyValue('--subcategory-menu-height');
        if (newTopValue !== currentTopValue) {
          this.progressBarContainer.style.setProperty('--subcategory-menu-height', newTopValue);
        }
      }
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      this.debouncedSetPosition();
      this.debouncedUpdateProgress();
    }
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      window.addEventListener('scroll', this.debouncedUpdateProgress, {
        passive: true
      });
      window.addEventListener('resize', this.handleResize, {
        passive: true
      });
    }
  }, {
    key: "updateProgress",
    value: function updateProgress() {
      if (!this.progressBar) return;
      var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
      var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      if (height <= 0) {
        this.progressBar.style.width = "100%";
        return;
      }
      var scrolled = winScroll / height * 100;
      scrolled = Math.max(0, Math.min(100, scrolled));
      this.progressBar.style.width = scrolled + "%";
    }
  }]);
}();
function initializeProgressBar() {
  new ProgressBar();
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeProgressBar);
} else {
  initializeProgressBar();
}
function initAuthorBylineComponents() {
  var hideTooltip = function hideTooltip(tooltipEl) {
    if (!tooltipEl) return;
    tooltipEl.classList.remove('is-visible');
    tooltipEl.setAttribute('hidden', 'true');
    var selector = ".author-profile-trigger[aria-controls=\"".concat(tooltipEl.id, "\"], .author-profile-trigger[data-tooltip-id=\"").concat(tooltipEl.id, "\"]");
    var trigger = document.querySelector(selector);
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  };
  var hideAllTooltips = function hideAllTooltips() {
    document.querySelectorAll('.author-tooltip.is-visible').forEach(hideTooltip);
  };
  document.querySelectorAll('.author-byline-group').forEach(function (containerRoot) {
    var toggleBtn = containerRoot.querySelector('.toggle-additional-contributors');
    if (toggleBtn) {
      var targetId = toggleBtn.getAttribute('aria-controls');
      var contributorsContainer = targetId ? containerRoot.querySelector("#".concat(targetId)) : null;
      if (contributorsContainer) {
        var isInitiallyOpen = toggleBtn.getAttribute('aria-expanded') === 'true';
        contributorsContainer.style.display = isInitiallyOpen ? 'block' : 'none';
        contributorsContainer.toggleAttribute('hidden', !isInitiallyOpen);
        toggleBtn.addEventListener('click', function () {
          var isOpen = toggleBtn.getAttribute('aria-expanded') === 'true';
          var show = !isOpen;
          toggleBtn.setAttribute('aria-expanded', String(show));
          contributorsContainer.style.display = show ? 'block' : 'none';
          contributorsContainer.toggleAttribute('hidden', !show);
        });
      }
    }
    containerRoot.querySelectorAll('.author-profile-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var tooltipId = trigger.getAttribute('aria-controls') || trigger.getAttribute('data-tooltip-id');
        if (!tooltipId) return;
        var tooltip = document.getElementById(tooltipId);
        if (!tooltip) return;
        if (tooltip.parentElement !== document.body) {
          document.body.appendChild(tooltip);
        }
        hideAllTooltips();
        tooltip.removeAttribute('hidden');
        tooltip.classList.add('is-visible');
        trigger.setAttribute('aria-expanded', 'true');
      });
    });
  });
  document.body.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('.author-tooltip__close');
    if (closeBtn) {
      var tooltipEl = closeBtn.closest('.author-tooltip');
      hideTooltip(tooltipEl);
      return;
    }
    var inTooltip = e.target.closest('.author-tooltip');
    var inTrigger = e.target.closest('.author-profile-trigger');
    if (!inTooltip && !inTrigger) {
      hideAllTooltips();
    }
  });
  document.body.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') hideAllTooltips();
  });
}
document.addEventListener('DOMContentLoaded', initAuthorBylineComponents);
